module.exports = __webpack_public_path__ + "static/img/logo.43b2e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manyRecruitImg/logo.png
// module id = BapH
// module chunks = 1